export default (initialState = {}) => {
  return () => {
    return {
      bill_date: null,
      bill_number: "",
      billing_address: "",
      buyer_name: "",
      buyer_gstin: "",
      date: new Date(),
      files: [],
      invc_date: null,
      invc_number: "",
      lineitems: [],
      number: "",
      payment_terms: "",
      po_id: {
        payment_terms: "",
      },
      po_info: {},
      remarks: "",
      reference_invcs: [],
      shipping_address: "",
      status_cd: "active",
      total_amount: 0,
      total_tax: 0,
      ...initialState,
    };
  };
};
